import React from 'react';
import PropTypes from 'prop-types';
import './Project-Filter.css';

export default function ProjectFilters({
  nameFilter,
  onNameChange,
  clientFilter,
  onClientChange,
  clients,
  onApply,
  onReset,
}) {
  return (
    <div className="hdow-filters">
      {/* Search by project name */}
      <div className="hdow-filter-group">
        <label htmlFor="project-search">Search Projects</label>
        <input
          id="project-search"
          type="search"
          placeholder="Type project name"
          value={nameFilter}
          onChange={e => onNameChange(e.target.value)}
        />
      </div>

      {/* Filter by Client */}
      <div className="hdow-filter-group">
        <label>Client</label>
        <select
          value={clientFilter}
          onChange={e => onClientChange(e.target.value)}
        >
          <option value="">All</option>
          {clients.map(opt => (
            <option key={opt} value={opt}>
              {opt}
            </option>
          ))}
        </select>
      </div>

      <div className="hdow-buttons">
        <button onClick={onReset} className="hdow-reset">
          Reset
        </button>
      </div>
    </div>
  );
}

ProjectFilters.propTypes = {
  nameFilter:     PropTypes.string.isRequired,
  onNameChange:   PropTypes.func.isRequired,
  clientFilter:   PropTypes.string.isRequired,
  onClientChange: PropTypes.func.isRequired,
  clients:        PropTypes.arrayOf(PropTypes.string).isRequired,
  onApply:        PropTypes.func.isRequired,
  onReset:        PropTypes.func.isRequired,
};
